// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__Grf4I","name":"Affair_name__k00ca","closeButton":"Affair_closeButton__ZUC7j"};